'use strict';
import { observeAddToCartButtons } from "../add-to-cart.js";

class AccountData {

    
    constructor(order_by, order, container, type) {
        this._container = document.getElementById(container);
        this._self = this;
        this._order_by = order_by;
        this._order = order;
        this._per_page = 10;
        this._page = 1;
        this._type = type;
        this._initialLoadDone = false;
        this._searchTerm = '';
        
        this._loadingEl = document.getElementById('account-loading');
        if (this._loadingEl) {
            this._loadingEl.style.display = 'none';
        }
        this._loadMoreButton = null;
        this._ordersCounterEl = null;
        this._totalOrders = 0;
        this._displayedOrdersCount = 0;

        if (this._type === 'orders') {
            this._rowsEl = document.getElementById('user-orders-rows');
            this._rowTemplate = document.getElementById('user-order-template');
            this._rowHeadersTemplate = document.getElementById('user-order-headers');
            this._noneTemplate = document.getElementById('user-orders-none');
            this._rowExpandable = document.getElementById('user-order-details');
            // Auto-load orders on initialization
            this.setupLoadMoreControls(); 
            this.getOrders(); // Auto-load first page
        } else if (this._type === 'products') {
            this._rowsEl = document.getElementById('user-products-rows');
            this._rowTemplate = document.getElementById('user-product-template');
            this._productOrderTemplate = document.getElementById('user-product-order-template');
            this._noneTemplate = document.getElementById('user-products-none');
            // Auto-load products on initialization like orders
            this.setupLoadProductsButton(); 
            this.setupProductSearch();
            this.setupOrderModal();
            this.getProducts(); // Auto-load products
        }
    }

    get products() {
        return this._products;
    }

    /**
     * @param {string} order_by
     */
    set order_by(order_by) {
        if(order_by == this._order_by) return;
        this._order_by = order_by;
        this._products = this.getProducts();
    }

    /**
     * @param {string} order
     */
    set order(order) {
        if(order == this._order) return;
        this._order = order;
        this._products = this.getProducts();
    }

    /**
     * @param {array} ordering
     */
    set ordering(ordering) {
        this._order_by = ordering.order_by;
        this._order = ordering.order;
        this.getProducts();
    }

    async getProducts() {
        try {
            this._products = await jQuery.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_var.url,
                data: {
                    action: "get_current_user_products",
                    order_by: this._order_by,
                    order: this._order,
                    search: this._searchTerm,
                    per_page: this._per_page,
                    page: this._page,
                    nonce: ajax_var.nonce
                }
            } ).done(function(response) {
                this.render(response, 'products')
                return response;
            }.bind(this));
        } catch (error) {
            console.error(error);
        }
    }

    async getOrders() {
        try {
            if (this._loadingEl) {
                this._loadingEl.style.display = 'block';
            }
            if (this._loadMoreButton) {
                this._loadMoreButton.disabled = true;
            }

            const response = await jQuery.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_var.url,
                data: {
                    action: "get_current_user_orders",
                    order_by: this._order_by,
                    order: this._order,
                    per_page: this._per_page,
                    page: this._page,
                    nonce: ajax_var.nonce
                }
            });

            if (response.success && response.data) {
                this.render(response.data, 'orders');
                this._page++;
                this._totalOrders = response.data.total_orders;
                this._initialLoadDone = true;
                this.updateOrdersDisplayInfo();
                if (this._displayedOrdersCount === 0 && response.data.data.length === 0) {
                    this._rowsEl.innerHTML = '';
                    this._rowsEl.appendChild(this._noneTemplate.content.cloneNode(true));
                }
            } else {
                this._initialLoadDone = true;
                if (this._page === 1) {
                    this._rowsEl.innerHTML = '';
                    this._rowsEl.appendChild(this._noneTemplate.content.cloneNode(true));
                }
                this.updateOrdersDisplayInfo();
            }

        } catch (error) {
            console.error(error);
            this._initialLoadDone = true;
            if (this._page === 1) {
                this._rowsEl.innerHTML = '';
                this._rowsEl.appendChild(this._noneTemplate.content.cloneNode(true));
            }
            this.updateOrdersDisplayInfo();
        } finally {
            if (this._loadingEl) {
                this._loadingEl.style.display = 'none';
            }
            if (this._loadMoreButton) {
                this._loadMoreButton.disabled = false;
            }
        }
    }

    async getOrder(id) {
        try {
            this._orders = await jQuery.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_var.url,
                data: {
                    action: "get_current_user_order",
                    id: id,
                    nonce: ajax_var.nonce
                }
            } ).done(function(response) {
                this.render(response.data, 'order')
                return response;
            }.bind(this));
        } catch (error) {
            console.error(error);
        }
    }

    async render(response, type) {
        if (this._loadingEl) {
            this._loadingEl.style.display = "none";
        }

        if (!'content' in document.createElement('template')) {
            console.log('Internet Explorer does not support template elements, cannot display products.')
            return;
        }

        if (type && type == 'products') {
            const productsData = response.data;

            if (this._page === 1 && this._rowsEl.querySelector('#loading-template-dynamic')) {
                const loadingInitial = this._rowsEl.querySelector('#loading-template-dynamic');
                if(loadingInitial) loadingInitial.remove();
            }

            if (this._page === 1 || !this._initialLoadDone) {
                this._rowsEl.innerHTML = '';
                this._displayedOrdersCount = 0;
            }

            if (!productsData || productsData.length == 0) {
                if (this._page === 1) {
                    this._rowsEl.appendChild(this._noneTemplate.content.cloneNode(true));
                }
                return;
            }

            // Group products by visibility and type
            this.groupAndRenderProducts(productsData);
            
            this._displayedOrdersCount += productsData.length;
        } else if (type && type == 'orders') {
            const ordersData = response.data;

            const initialLoadingSpinner = this._rowsEl.querySelector('.animate-spin');
            if (this._page === 1 && initialLoadingSpinner) {
                this._rowsEl.innerHTML = '';
            }
            else if (this._page === 2 && this._rowsEl.innerHTML === '') {
            }
            else if (this._page === 1 || !this._initialLoadDone) {
                this._rowsEl.innerHTML = '';
            }

            if (!ordersData || ordersData.length == 0) {
                if (this._page === 1 && this._rowsEl.innerHTML.trim() === '') {
                    this._rowsEl.appendChild(this._noneTemplate.content.cloneNode(true));
                }
                return;
            }

            this._displayedOrdersCount += ordersData.length;

            ordersData.forEach(result => {
                var clone = this._rowTemplate.content.cloneNode(true);

                clone.querySelectorAll(".user-order-id")[0].textContent = result.id;
                clone.querySelectorAll(".user-order-date")[0].textContent = result.date;
                clone.querySelectorAll(".user-order-status")[0].textContent = result.status_label;
                clone.querySelectorAll(".user-order-cost")[0].textContent = result.cost;
                clone.querySelectorAll(".user-order-quantity")[0].textContent = result.quantity;
                clone.querySelectorAll(".user-order-summary")[0].id = 'user-order-summary-'+result.id;
                clone.querySelectorAll(".user-order-summary")[0].dataset.id = result.id;
                clone.querySelectorAll(".user-order-expandable")[0].id = 'user-order-expandable-'+result.id;

                this._rowsEl.appendChild(clone);

                document.getElementById('user-order-summary-'+result.id).addEventListener('click', function(e) {
                    let summary = null;

                    if (e.srcElement.classList.contains('user-order-summary')) {
                        summary = e.srcElement;
                    } else {
                        summary = e.srcElement.closest('.user-order-summary');
                    }

                    let id = summary.dataset.id;
                    let expandable = document.getElementById('user-order-expandable-'+id);
                    let loaded = expandable.classList.contains('loaded');
                    let expanded = expandable.classList.contains('expanded');
                    let chevron = summary.querySelectorAll(".user-order-chevron")[0];

                    const chevronClasses = ['rotate-180'];
                    const summaryClasses = ['expanded', 'bg-versa-100', 'font-semibold'];


                    if (!expanded) {

                        if (!loaded) {
                            summary.classList.add('loading');
                            this.getOrder(result.id);
                        }
                        chevron.classList.add(...chevronClasses)
                        summary.classList.add(...summaryClasses)
                        expandable.classList.add('max-h-full')
                        expandable.classList.remove('max-h-0');
                        expandable.classList.add('expanded');
                    } else {
                        chevron.classList.remove(...chevronClasses)
                        summary.classList.remove(...summaryClasses)
                        expandable.classList.remove('max-h-full')
                        expandable.classList.add('max-h-0')
                        expandable.classList.remove('expanded');
                    }
                }.bind(this));

            })

        } else if (type && type == 'order') {
            const result = response[0];
            if (!result) {
                console.error("Order details not found in response", response);
                return;
            }

            const expandableEl = document.getElementById('user-order-expandable-'+result.id);
            expandableEl.innerHTML = '';
            expandableEl.appendChild(this._rowHeadersTemplate.content.cloneNode(true))
            const productRowsEl = expandableEl.querySelectorAll('.user-order-products')[0]
            
            if (expandableEl.classList.contains('loaded')) return;



            // ----------- Items Start -----------
            result.items.forEach(item => {
                var productTemplate = document.getElementById('user-order-product').content.cloneNode(true);
                productTemplate.querySelectorAll(".user-order-product-name")[0].textContent = item.name;
                productTemplate.querySelectorAll(".user-order-product-url")[0].href = item.url;
                productTemplate.querySelectorAll(".user-order-product-sku")[0].textContent = 'Art. nr. ' + item.sku;
                productTemplate.querySelectorAll(".user-order-product-quantity")[0].textContent = item.quantity + ' st';
                productTemplate.querySelectorAll(".user-order-product-quantity")[1].textContent = item.quantity + ' st';

                var subtotalParsed = (new DOMParser()).parseFromString(item.sub_formatted, 'text/html').documentElement;
                productTemplate.querySelectorAll(".user-order-product-subtotal_with_tax")[0].appendChild(subtotalParsed.querySelector('body > *'));

                var subtotalPerQtyParsed = (new DOMParser()).parseFromString(item.sub_formatted_per_qty, 'text/html').documentElement;
                productTemplate.querySelectorAll(".user-order-product-subtotal_with_tax_per_qty")[0].appendChild(subtotalPerQtyParsed.querySelector('body > *'));

                let thumbnail = item.thumbnail;
                var thumbnailParsed = (new DOMParser()).parseFromString(thumbnail, 'text/html').querySelector('img');
                let thumbnailEl = productTemplate.querySelectorAll(".user-order-product-thumbnail")[0];
                thumbnailEl.src = thumbnailParsed.src;
                thumbnailEl.alt = thumbnailParsed.alt;
                thumbnailEl.srcset = thumbnailParsed.srcset;
                thumbnailEl.height = thumbnailParsed.height;
                thumbnailEl.width = thumbnailParsed.width;
                thumbnailEl.sizes = thumbnailParsed.sizes;
                thumbnailEl.loading = thumbnailParsed.loading;


                // ----------- Current Price Start -----------
                var currentPriceParsed = (new DOMParser()).parseFromString(item.current_price_formatted, 'text/html').documentElement;
                productTemplate.querySelectorAll(".user-order-product-current-price")[0].insertAdjacentHTML('beforeend', currentPriceParsed.querySelector('body').innerHTML);
                    

                // ----------- Current Price End -----------


                // ----------- Add to cart buttons Start -----------

                if (item.is_purchasable) {
                    var addToCartButtonTemplate = document.getElementById('add-to-cart-button-in-stock-template').content.cloneNode(true);
                } else if (item.allow_backorders) {
                    var addToCartButtonTemplate = document.getElementById('add-to-cart-button-backorder-template').content.cloneNode(true);
                } else {
                    var addToCartButtonTemplate = document.getElementById('add-to-cart-button-out-of-stock-template').content.cloneNode(true);
                }

                addToCartButtonTemplate.querySelectorAll(".add_to_cart_button").forEach( (el) => {
                    el.dataset.product_id = item.id
                    el.dataset.variation_id = item.variation_id
                    el.value = item.id
                    el.dataset.sku = item.sku
                });

                productTemplate.querySelectorAll(".user-order-product-add-to-cart-button")[0].appendChild(addToCartButtonTemplate);

                // ----------- Add to cart buttons End -----------


                productRowsEl.appendChild(productTemplate);

            });

            expandableEl.classList.remove('loading');
            expandableEl.classList.add('loaded');
            expandableEl.appendChild(productRowsEl);
            // ----------- Items End -----------

            // ----------- Costs Start -----------
                var costsTemplate = document.getElementById('user-order-costs').content.cloneNode(true);


                // ----------- Subtotal Start -----------

                if (result.formatted_subtotal) {
                    var subtotalCostTemplate = document.getElementById('user-order-cost-subtotal').content.cloneNode(true);
                    var subtotalCostParsed = (new DOMParser()).parseFromString(result.formatted_subtotal, 'text/html').documentElement;
                    subtotalCostTemplate.querySelectorAll(".user-order-cost-subtotal-total")[0].appendChild(subtotalCostParsed.querySelector('body > *'));
                    subtotalCostTemplate.querySelectorAll(".user-order-cost-subtotal-label")[0].textContent = result.quantity;
                    costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(subtotalCostTemplate);
                    productRowsEl.appendChild(subtotalCostTemplate);
                }
                
                // ----------- Subtotal End -----------


                // ----------- Coupons Start -----------

                if (result.coupons && result.coupons.length > 0) {

                    var discountsTemplate = document.getElementById('user-order-cost-coupon').content.cloneNode(true);
                    var discountLines = discountsTemplate.querySelectorAll('.user-order-cost-coupon-list')[0];

                    result.coupons.forEach(item => {
                        var discountLineTemplate = document.getElementById('user-order-cost-coupon-line').content.cloneNode(true);



                        discountLineTemplate.querySelectorAll(".user-order-cost-coupon-label")[0].textContent = item.code;

                        var totalParsed = (new DOMParser()).parseFromString(item.discount_formatted, 'text/html').documentElement;
                        discountLineTemplate.querySelectorAll(".user-order-cost-coupon-total")[0].appendChild(totalParsed.querySelector('body > *'));

                        discountLines.appendChild(discountLineTemplate);

                    });

                    costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(discountsTemplate);

                }
                // ----------- Coupons End -----------


                // ----------- Fees Start -----------

                if (result.fees && result.fees.length > 0) {

                    var feesTemplate = document.getElementById('user-order-cost-fee').content.cloneNode(true);
                    var feeLines = feesTemplate.querySelectorAll('.user-order-cost-fee-list')[0];

                    result.fees.forEach(item => {
                        var feeLineTemplate = document.getElementById('user-order-cost-fee-line').content.cloneNode(true);



                        feeLineTemplate.querySelectorAll(".user-order-cost-fee-label")[0].textContent = item.name;

                        var totalParsed = (new DOMParser()).parseFromString(item.fee_formatted, 'text/html').documentElement;
                        feeLineTemplate.querySelectorAll(".user-order-cost-fee-total")[0].appendChild(totalParsed.querySelector('body'));
                        
                        feeLines.appendChild(feeLineTemplate);

                    });

                    costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(feesTemplate);

                }
                // ----------- Fees End -----------


                // ----------- Shipping cost Start -----------

                if (result.shipping_cost_formatted) {
                    var shippingCostTemplate = document.getElementById('user-order-cost-shipping').content.cloneNode(true);
                    var shippingCostParsed = (new DOMParser()).parseFromString(result.shipping_cost_formatted, 'text/html').documentElement;
                    shippingCostTemplate.querySelectorAll(".user-order-cost-shipping-total")[0].insertAdjacentHTML('beforeend', shippingCostParsed.querySelector('body').innerHTML);
                    costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(shippingCostTemplate);
                    productRowsEl.appendChild(shippingCostTemplate);
                }
                
                // ----------- Shipping cost End -----------


                // ----------- Refunds Start -----------

                if (result.refunds) {
                    result.refunds.forEach(item => {
                        var costTemplate = document.getElementById('user-order-cost-credit').content.cloneNode(true);
                        
                        costTemplate.querySelectorAll(".user-order-cost-credit-date")[0].textContent = item.date_formatted;

                        var totalParsed = (new DOMParser()).parseFromString(item.total_with_tax_formatted, 'text/html').documentElement;
                        costTemplate.querySelectorAll(".user-order-cost-credit-total")[0].insertAdjacentHTML('beforeend', totalParsed.querySelector('body').innerHTML);

                        costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(costTemplate);

                    });
                }

                // ----------- Refunds End -----------


                // ----------- Discount Start -----------

                if (result.discount_formatted) {
                    var discountTemplate = document.getElementById('user-order-cost-discount').content.cloneNode(true);
                    var discountParsed = (new DOMParser()).parseFromString(result.discount_formatted, 'text/html').documentElement;
                    var discountTaxParsed = (new DOMParser()).parseFromString(result.discount_tax_formatted, 'text/html').documentElement;
                    discountTemplate.querySelectorAll(".user-order-cost-discount-total")[0].insertAdjacentHTML('beforeend', discountParsed.querySelector('body').innerHTML);
                    costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(discountTemplate);
                    productRowsEl.appendChild(discountTemplate);
                }
                
                // ----------- Discount End -----------


                // ----------- Total cost Start -----------

                if (result.formatted_order_total) {
                    var totalCostTemplate = document.getElementById('user-order-cost-total').content.cloneNode(true);
                    var totalCostParsed = (new DOMParser()).parseFromString(result.formatted_order_total, 'text/html').documentElement;
                    totalCostTemplate.querySelectorAll(".user-order-cost-total-total")[0].insertAdjacentHTML('beforeend', totalCostParsed.querySelector('body').innerHTML);
                    costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(totalCostTemplate);
                    productRowsEl.appendChild(totalCostTemplate);
                }
                
                // ----------- Total cost End -----------

                productRowsEl.appendChild(costsTemplate);

            // ----------- Costs End -----------

            

            // ----------- Details Start -----------
            const detailsEl = expandableEl.querySelectorAll('.user-order-details')[0]
            var detailsTemplate = document.getElementById('user-order-details').content.cloneNode(true);

            detailsTemplate.querySelectorAll(".user-order-shipping-method")[0].textContent = result.shipping_custom_title;
            detailsTemplate.querySelectorAll(".user-order-shipping-company")[0].textContent = result.shipping_company;

            if (result.shipping_tracking) {
                detailsTemplate.querySelectorAll(".user-order-tracking")[0].textContent = result.shipping_tracking;
                detailsTemplate.querySelectorAll(".user-order-tracking-button")[0].href += result.shipping_tracking;
                detailsTemplate.querySelectorAll(".user-order-tracking-button")[0].classList.remove('hidden');
            }
            detailsTemplate.querySelectorAll(".user-order-id")[0].textContent = result.id;
            detailsTemplate.querySelectorAll(".user-order-status")[0].textContent = result.status_label;
            detailsTemplate.querySelectorAll(".user-order-payment-method")[0].textContent = result.payment_method_label;
            detailsTemplate.querySelectorAll(".user-order-payment-transaction-id")[0].textContent = result.payment_transaction_id;

            if (result.payment_method_label.includes('Faktura')) {
                detailsTemplate.querySelectorAll(".user-order-payment-method-invoice")[0].classList.remove('hidden');
            }

            var billingAddressParsed = (new DOMParser()).parseFromString(result.billing_address, 'text/html').documentElement;
            detailsTemplate.querySelectorAll(".user-order-billing-address")[0].appendChild(billingAddressParsed.querySelector('body'));

            var shippingAddressParsed = (new DOMParser()).parseFromString(result.shipping_address, 'text/html');
            detailsTemplate.querySelectorAll(".user-order-shipping-address")[0].appendChild(shippingAddressParsed.querySelector('body'));

            detailsEl.appendChild(detailsTemplate);
            // ----------- Details End -----------



            // ----------- Info Start -----------
            const infoEl = expandableEl.querySelectorAll('.user-order-info')[0];
            var infoTemplate = document.getElementById('user-order-info').content.cloneNode(true);
            var infoTemplateMessageEl = infoTemplate.querySelectorAll('.user-order-info-message')[0];
            if (result.status === 'cancelled') {
                infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-cancelled').content.cloneNode(true));
            } else if (result.status === 'processing') {
                infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-processing').content.cloneNode(true));
            } else if (result.status === 'completed') {
                infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-completed').content.cloneNode(true));
            } else if (result.status === 'refunded') {
                infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-refunded').content.cloneNode(true));
            } else if (result.status === 'pending') {
                infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-pending').content.cloneNode(true));
            }

            infoEl.appendChild(infoTemplate);
            // ----------- Info End -----------




            expandableEl.appendChild(detailsTemplate);

            observeAddToCartButtons();
            


        }
    }

    setupLoadMoreControls() {
        if (this._type === 'orders') {
            let controlsContainer = document.getElementById('orders-controls-container');
            if (!controlsContainer) {
                controlsContainer = document.createElement('div');
                controlsContainer.id = 'orders-controls-container';
                controlsContainer.className = 'mt-6 mb-4 text-center';
                if (this._rowsEl.parentNode) {
                    this._rowsEl.parentNode.appendChild(controlsContainer); 
                }
            }

            this._ordersCounterEl = document.getElementById('orders-counter');
            if (!this._ordersCounterEl) {
                this._ordersCounterEl = document.createElement('p');
                this._ordersCounterEl.id = 'orders-counter';
                this._ordersCounterEl.className = 'mb-2 text-sm text-gray-600';
                controlsContainer.appendChild(this._ordersCounterEl);
            }

            this._loadMoreButton = document.getElementById('load-more-orders');
            if (!this._loadMoreButton) {
                this._loadMoreButton = document.createElement('button');
                this._loadMoreButton.id = 'load-more-orders';
                this._loadMoreButton.className = 'mx-auto block mt-2 mb-2 px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 disabled:opacity-50'; 
                controlsContainer.appendChild(this._loadMoreButton);
            }
            
            this._loadMoreButton.addEventListener('click', () => this.getOrders());
            this.updateOrdersDisplayInfo();
        }
    }

    updateOrdersDisplayInfo() {
        if (this._ordersCounterEl) {
            if (this._initialLoadDone && this._totalOrders > 0) {
                this._ordersCounterEl.textContent = wp.i18n.sprintf(versaTranslate('Showing %1$d of %2$d orders', 'versa'), this._displayedOrdersCount, this._totalOrders);
            } else if (this._initialLoadDone && this._totalOrders === 0) {
                this._ordersCounterEl.textContent = versaTranslate('You have no previous orders.', 'versa');
            } else {
                this._ordersCounterEl.textContent = '';
            }
        }

        if (this._loadMoreButton) {
            if (this._initialLoadDone && this._displayedOrdersCount < this._totalOrders) {
                this._loadMoreButton.textContent = versaTranslate('Load more orders', 'versa');
                this._loadMoreButton.style.display = 'block';
            } else {
                this._loadMoreButton.style.display = 'none';
            }
        }
    }

    // Placeholder for actual product loading controls, similar to orders
    setupLoadProductsButton() {
        if (this._type === 'products') {
            const initialLoadingSpinnerProducts = document.getElementById('products-loading-initial');
            if (initialLoadingSpinnerProducts) {
                initialLoadingSpinnerProducts.style.display = 'none';
            }

            // For now, products don't need a load more button since we load all at once
            // This method is kept for future pagination if needed
        }
    }

    setupProductSearch() {
        const searchInput = document.getElementById('user-products-search');
        if (searchInput) {
            let searchTimeout;
            searchInput.addEventListener('input', (e) => {
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(() => {
                    this._searchTerm = e.target.value.trim();
                    this._page = 1;
                    this._initialLoadDone = false;
                    this.getProducts();
                }, 300); // Debounce search for 300ms
            });
        }
    }

    setupOrderModal() {
        const modal = document.getElementById('order-modal');
        const closeButton = document.getElementById('close-order-modal');
        
        if (closeButton && modal) {
            closeButton.addEventListener('click', () => {
                modal.classList.add('hidden');
            });
            
            // Close modal when clicking outside
            modal.addEventListener('click', (e) => {
                if (e.target === modal) {
                    modal.classList.add('hidden');
                }
            });
        }
    }

    toggleProductExpansion(index, product) {
        const productSummary = this._rowsEl.querySelector(`[data-product-index="${index}"]`);
        if (!productSummary) return;
        
        const expandable = document.getElementById('user-product-expandable-' + index);
        const chevron = productSummary.querySelector('.user-product-chevron');
        const expanded = expandable.classList.contains('expanded');

        const chevronClasses = ['rotate-180'];
        const summaryClasses = ['expanded', 'bg-versa-100', 'font-semibold'];

        if (!expanded) {
            // Expand
            chevron.classList.add(...chevronClasses);
            productSummary.classList.add(...summaryClasses);
            expandable.classList.add('max-h-full');
            expandable.classList.remove('max-h-0');
            expandable.classList.add('expanded');
            
            // Populate order history if not already done
            if (!expandable.dataset.loaded) {
                this.populateOrderHistory(expandable, product);
                expandable.dataset.loaded = 'true';
            }
        } else {
            // Collapse
            chevron.classList.remove(...chevronClasses);
            productSummary.classList.remove(...summaryClasses);
            expandable.classList.remove('max-h-full');
            expandable.classList.add('max-h-0');
            expandable.classList.remove('expanded');
        }
    }

    populateOrderHistory(expandable, product) {
        const ordersList = expandable.querySelector('.user-product-orders-list');
        if (!ordersList || !product.orders) return;

        ordersList.innerHTML = ''; // Clear existing content

        product.orders.forEach(order => {
            const orderClone = this._productOrderTemplate.content.cloneNode(true);
            
            orderClone.querySelector('.user-product-order-id').textContent = order.id;
            orderClone.querySelector('.user-product-order-date').textContent = order.date;
            orderClone.querySelector('.user-product-order-status').textContent = order.status_label;
            orderClone.querySelector('.user-product-order-quantity').textContent = order.quantity;
            
            // Parse HTML for formatted price instead of showing raw HTML
            const totalElement = orderClone.querySelector('.user-product-order-total');
            if (order.formatted_total) {
                // Create a temporary div to parse the HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = order.formatted_total;
                // Extract just the text content (formatted price without HTML tags)
                totalElement.textContent = tempDiv.textContent || tempDiv.innerText || order.formatted_total;
            } else {
                // Fallback to basic price formatting
                totalElement.textContent = order.total + ' kr';
            }
            
            // Add status styling
            const statusEl = orderClone.querySelector('.user-product-order-status');
            this.applyOrderStatusStyling(statusEl, order.status);
            
            // Add click handler to show order modal
            const orderItem = orderClone.querySelector('.user-product-order-item');
            orderItem.addEventListener('click', () => {
                this.showOrderModal(order.id);
            });
            
            ordersList.appendChild(orderClone);
        });
    }

    applyOrderStatusStyling(element, status) {
        element.className = 'user-product-order-status px-2 py-1 rounded text-xs';
        
        switch(status) {
            case 'completed':
                element.classList.add('bg-green-100', 'text-green-800');
                break;
            case 'processing':
                element.classList.add('bg-blue-100', 'text-blue-800');
                break;
            case 'pending':
                element.classList.add('bg-yellow-100', 'text-yellow-800');
                break;
            case 'cancelled':
                element.classList.add('bg-red-100', 'text-red-800');
                break;
            default:
                element.classList.add('bg-gray-100', 'text-gray-800');
        }
    }

    async showOrderModal(orderId) {
        const modal = document.getElementById('order-modal');
        const modalContent = document.getElementById('order-modal-content');
        const modalOrderId = document.getElementById('modal-order-id');
        
        if (!modal || !modalContent || !modalOrderId) return;
        
        // Show modal with loading state
        modalOrderId.textContent = orderId;
        modalContent.innerHTML = `
            <div class="flex justify-center items-center h-20">
                <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-versa-500"></div>
            </div>
        `;
        modal.classList.remove('hidden');
        
        try {
            // Get order details using the existing method
            const response = await jQuery.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_var.url,
                data: {
                    action: "get_current_user_order",
                    id: orderId,
                    nonce: ajax_var.nonce
                }
            });
            
            if (response.success && response.data && response.data.length > 0) {
                this.renderOrderInModal(response.data[0], modalContent);
            } else {
                modalContent.innerHTML = `<p class="text-center text-gray-500">${versaTranslate('Order details could not be loaded.', 'versa')}</p>`;
            }
        } catch (error) {
            console.error('Error loading order details:', error);
            modalContent.innerHTML = `<p class="text-center text-red-500">${versaTranslate('Error loading order details.', 'versa')}</p>`;
        }
    }

    renderOrderInModal(order, container) {
        // Create a simplified version of order details for the modal
        const orderHtml = `
            <div class="space-y-4">
                <div class="bg-gray-50 p-4 rounded">
                    <div class="grid grid-cols-2 gap-4 text-sm">
                        <div><strong>${versaTranslate('Status:', 'versa')}</strong> ${order.status_label}</div>
                        <div><strong>${versaTranslate('Date:', 'versa')}</strong> ${order.date}</div>
                        <div><strong>${versaTranslate('Total:', 'versa')}</strong> ${order.formatted_order_total}</div>
                        <div><strong>${versaTranslate('Items:', 'versa')}</strong> ${order.quantity} st</div>
                    </div>
                </div>
                
                <div>
                    <h4 class="font-medium mb-2">${versaTranslate('Products:', 'versa')}</h4>
                    <div class="space-y-2">
                        ${order.items.map(item => `
                            <div class="flex justify-between items-center p-2 bg-gray-50 rounded">
                                <div>
                                    <div class="font-medium">${item.name}</div>
                                    <div class="text-sm text-gray-600">${versaTranslate('SKU:', 'versa')} ${item.sku}</div>
                                </div>
                                <div class="text-right">
                                    <div>${item.quantity} st</div>
                                    <div class="text-sm">${item.sub_formatted}</div>
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
                
                ${order.payment_method_label ? `
                    <div class="border-t pt-4">
                        <strong>${versaTranslate('Payment method:', 'versa')}</strong> ${order.payment_method_label}
                    </div>
                ` : ''}
            </div>
        `;
        
        container.innerHTML = orderHtml;
    }

    groupAndRenderProducts(productsData) {
        // Group all products by type (both visible and hidden together)
        const productGroups = {};
        
        productsData.forEach(product => {
            const groupKey = product.pa_type_slug || 'uncategorized';
            const groupName = product.pa_type_name || 'Uncategorized';
            
            if (!productGroups[groupKey]) {
                productGroups[groupKey] = {
                    name: groupName,
                    products: []
                };
            }
            productGroups[groupKey].products.push(product);
        });
        
        // Clear existing content
        this._rowsEl.innerHTML = '';
        
        // Render all product groups (which will internally separate visible/hidden)
        this.renderProductGroups(productGroups, this._rowsEl, false);
        
        // Initialize add-to-cart functionality for the newly rendered products
        observeAddToCartButtons();
    }
    
    renderProductGroups(groups, container, isHidden = false) {
        let globalProductIndex = this._displayedOrdersCount; // Start from current displayed count
        
        Object.keys(groups).sort().forEach(groupKey => {
            const group = groups[groupKey];
            const sectionEl = this.createProductSection(group.name, group.products.length, isHidden);
            const productsContainer = sectionEl.querySelector('.product-type-products');
            
            // Separate visible and hidden products within this type
            const visibleProducts = group.products.filter(product => product.is_visible);
            const hiddenProducts = group.products.filter(product => !product.is_visible);
            
            // Add visible products first
            if (visibleProducts.length > 0) {
                if (hiddenProducts.length > 0) {
                    // Add a header for visible products if there are also hidden ones
                    const visibleHeader = document.createElement('div');
                    visibleHeader.className = 'px-3 sm:px-4 py-2 bg-green-50 border-b border-green-200';
                    visibleHeader.innerHTML = `
                        <h5 class="text-sm font-medium text-green-800 flex items-center">
                            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                            </svg>
                            ${versaTranslate('Available Products', 'versa')} (${visibleProducts.length})
                        </h5>
                    `;
                    productsContainer.appendChild(visibleHeader);
                }
                
                visibleProducts.forEach((product) => {
                    const productEl = this.renderSingleProduct(product, globalProductIndex);
                    productsContainer.appendChild(productEl);
                    globalProductIndex++; // Increment for each product
                });
            }
            
            // Add hidden products section
            if (hiddenProducts.length > 0) {
                const hiddenHeader = document.createElement('div');
                hiddenHeader.className = 'px-3 sm:px-4 py-2 bg-gray-50 border-b border-gray-200';
                hiddenHeader.innerHTML = `
                    <h5 class="text-sm font-medium text-gray-700 flex items-center">
                        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"></path>
                        </svg>
                        ${versaTranslate('Discontinued Products', 'versa')} (${hiddenProducts.length})
                    </h5>
                    <p class="text-xs text-gray-600 mt-1">${versaTranslate('No longer available for purchase', 'versa')}</p>
                `;
                productsContainer.appendChild(hiddenHeader);
                
                hiddenProducts.forEach((product) => {
                    const productEl = this.renderSingleProduct(product, globalProductIndex);
                    // Add a subtle visual indication that this product is hidden
                    const productElement = productEl.querySelector('.user-product-summary');
                    if (productElement) {
                        productElement.classList.add('opacity-75');
                    }
                    productsContainer.appendChild(productEl);
                    globalProductIndex++; // Increment for each product
                });
            }
            
            container.appendChild(sectionEl);
        });
        
        // Update the displayed orders count with the final global index
        this._displayedOrdersCount = globalProductIndex;
    }
    
    createProductSection(typeName, productCount, isHidden = false) {
        const sectionTemplate = document.getElementById('product-type-section-template');
        if (!sectionTemplate) {
            // Fallback if template not found
            const fallbackDiv = document.createElement('div');
            fallbackDiv.className = 'product-type-section mb-6';
            fallbackDiv.innerHTML = `
                <div class="border-l-4 ${isHidden ? 'border-l-gray-400' : 'border-l-versa-500'} border rounded-lg bg-white shadow-sm">
                    <button class="w-full text-left py-3 px-4 ${isHidden ? 'bg-gray-50 hover:bg-gray-100' : 'bg-versa-50 hover:bg-versa-100'} rounded-t-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-versa-500 focus:ring-inset product-type-header">
                        <div class="flex items-center justify-between">
                            <div>
                                <h3 class="text-base font-semibold ${isHidden ? 'text-gray-700' : 'text-versa-800'} mb-0.5">${typeName}</h3>
                                <p class="text-xs text-gray-600">${productCount} ${productCount === 1 ? 'product' : 'products'}</p>
                            </div>
                            <div class="flex items-center space-x-2">
                                <span class="text-xs text-gray-500 hidden sm:block product-type-toggle-text">${versaTranslate('Expand', 'versa')}</span>
                                <svg class="w-4 h-4 ${isHidden ? 'text-gray-600' : 'text-versa-600'} transform transition-transform duration-200 product-type-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="transform: rotate(-90deg);">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </div>
                        </div>
                    </button>
                    <div class="product-type-products overflow-hidden transition-all duration-300 max-h-0 divide-y">
                    </div>
                </div>
            `;
            return fallbackDiv;
        }
        
        const clone = sectionTemplate.content.cloneNode(true);
        const titleEl = clone.querySelector('.product-type-title');
        const countEl = clone.querySelector('.product-type-count');
        const headerBtn = clone.querySelector('.product-type-header');
        const chevron = clone.querySelector('.product-type-chevron');
        const toggleText = clone.querySelector('.product-type-toggle-text');
        const productsContainer = clone.querySelector('.product-type-products');
        
        if (titleEl) titleEl.textContent = typeName;
        if (countEl) countEl.textContent = `${productCount} ${productCount === 1 ? 'product' : 'products'}`;
        
        // Update styling for hidden sections
        if (isHidden) {
            const headerDiv = clone.querySelector('.border-l-4');
            const headerButton = clone.querySelector('.product-type-header');
            if (headerDiv) {
                headerDiv.className = headerDiv.className.replace('border-l-versa-500', 'border-l-gray-400');
            }
            if (headerButton) {
                headerButton.className = headerButton.className.replace('bg-versa-50 hover:bg-versa-100', 'bg-gray-50 hover:bg-gray-100');
            }
            if (titleEl) {
                titleEl.className = titleEl.className.replace('text-versa-800', 'text-gray-700');
            }
            if (chevron) {
                chevron.className = chevron.className.replace('text-versa-600', 'text-gray-600');
            }
        }
        
        // Add collapsible functionality
        if (headerBtn && productsContainer && chevron && toggleText) {
            // Initialize in collapsed state
            productsContainer.classList.add('max-h-0');
            productsContainer.classList.remove('max-h-none');
            productsContainer.style.maxHeight = '0px';
            chevron.style.transform = 'rotate(-90deg)';
            toggleText.textContent = versaTranslate('Expand', 'versa');
            
            headerBtn.addEventListener('click', () => {
                const isExpanded = !productsContainer.classList.contains('max-h-0');
                
                if (isExpanded) {
                    // Collapse
                    productsContainer.style.maxHeight = productsContainer.scrollHeight + 'px';
                    requestAnimationFrame(() => {
                        productsContainer.classList.add('max-h-0');
                        productsContainer.classList.remove('max-h-none');
                        productsContainer.style.maxHeight = '0px';
                    });
                    chevron.style.transform = 'rotate(-90deg)';
                    toggleText.textContent = versaTranslate('Expand', 'versa');
                } else {
                    // Expand
                    productsContainer.classList.remove('max-h-0');
                    productsContainer.style.maxHeight = productsContainer.scrollHeight + 'px';
                    // After animation completes, remove max-height so content can grow naturally
                    setTimeout(() => {
                        if (!productsContainer.classList.contains('max-h-0')) {
                            productsContainer.style.maxHeight = 'none';
                            productsContainer.classList.add('max-h-none');
                        }
                    }, 300);
                    chevron.style.transform = 'rotate(0deg)';
                    toggleText.textContent = versaTranslate('Collapse', 'versa');
                }
            });
            
            // Add touch-friendly interaction
            headerBtn.style.minHeight = '44px'; // iOS recommended touch target
        }
        
        // Add divide-y class for product separation
        if (productsContainer) {
            productsContainer.classList.add('divide-y');
        }
        
        return clone;
    }
    
    renderSingleProduct(product, productIndex) {
        const clone = this._rowTemplate.content.cloneNode(true);

        clone.querySelectorAll(".user-product-name")[0].textContent = product.name;
        clone.querySelectorAll(".user-product-thumbnail")[0].src = product.thumbnail;
        clone.querySelectorAll(".user-product-sku")[0].textContent = product.sku;
        clone.querySelectorAll(".user-product-quantity")[0].textContent = product.quantity;
        clone.querySelectorAll(".user-product-purchase_date")[0].textContent = product.purchase_date_formatted;
        
        // Set up product link
        const productLink = clone.querySelector(".user-product-link");
        if (productLink) {
            productLink.href = product.permalink || '#';
        }
        
        // Set up reorder section data
        const addToCartBtn = clone.querySelector(".user-product-add-to-cart");
        const quantityInput = clone.querySelector(".user-product-reorder-quantity");
        const quantityDecrease = clone.querySelector(".quantity-decrease");
        const quantityIncrease = clone.querySelector(".quantity-increase");
        const stockStatus = clone.querySelector(".user-product-stock-status");
        const reorderSection = clone.querySelector(".user-product-reorder-section");
        
        if (addToCartBtn) {
            addToCartBtn.dataset.productId = product.id;
            addToCartBtn.dataset.productSku = product.sku;
            addToCartBtn.dataset.productIndex = productIndex;
            
            // Add WooCommerce add-to-cart classes and attributes for theme integration
            addToCartBtn.classList.add('add_to_cart_button');
            addToCartBtn.setAttribute('data-product_id', product.id);
            addToCartBtn.setAttribute('data-product_sku', product.sku);
            addToCartBtn.setAttribute('data-quantity', '1'); // Default quantity
            addToCartBtn.setAttribute('value', product.id);
            addToCartBtn.setAttribute('type', 'submit');
            addToCartBtn.setAttribute('name', 'add-to-cart');
            
            // Handle variation data
            if (product.variation_id && product.variation_id !== '0') {
                addToCartBtn.dataset.variationId = product.variation_id;
                addToCartBtn.setAttribute('data-variation_id', product.variation_id);
            }
        }
        
        // Set quantity control data attributes
        if (quantityInput) {
            quantityInput.dataset.productIndex = productIndex;
        }
        if (quantityDecrease) {
            quantityDecrease.dataset.productIndex = productIndex;
        }
        if (quantityIncrease) {
            quantityIncrease.dataset.productIndex = productIndex;
        }
        
        // Set stock status and button state
        if (stockStatus && addToCartBtn && reorderSection) {
            const maxStock = product.stock || 999; // Default to 999 if no stock limit
            
            // Set max attribute on quantity input
            if (quantityInput) {
                quantityInput.setAttribute('max', maxStock);
                quantityInput.addEventListener('input', (e) => {
                    const value = parseInt(e.target.value);
                    if (value > maxStock) {
                        e.target.value = maxStock;
                    }
                    if (value < 1) {
                        e.target.value = 1;
                    }
                });
            }
            
            if (product.in_stock && product.purchasable && product.status === 'publish') {
                stockStatus.textContent = `${versaTranslate('In stock', 'versa')} (${maxStock > 999 ? '999+' : maxStock} ${versaTranslate('available', 'versa')})`;
                stockStatus.className = 'user-product-stock-status font-medium text-green-600';
                addToCartBtn.disabled = false;
                addToCartBtn.className = 'user-product-add-to-cart bg-versa-700 hover:bg-versa-800 text-white px-3 py-1.5 rounded text-xs font-medium transition-colors flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed';
                
                // Enable quantity controls
                if (quantityInput) quantityInput.disabled = false;
                if (quantityDecrease) quantityDecrease.disabled = false;
                if (quantityIncrease) quantityIncrease.disabled = false;
            } else if (product.status !== 'publish') {
                stockStatus.textContent = versaTranslate('Discontinued', 'versa');
                stockStatus.className = 'user-product-stock-status font-medium text-gray-500';
                addToCartBtn.disabled = true;
                addToCartBtn.querySelector('.add-to-cart-text').textContent = versaTranslate('Unavailable', 'versa');
                addToCartBtn.className = 'user-product-add-to-cart bg-gray-400 text-white px-3 py-1.5 rounded text-xs font-medium flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed';
                reorderSection.style.opacity = '0.6';
                
                // Disable quantity controls
                if (quantityInput) {
                    quantityInput.disabled = true;
                    quantityInput.value = 1; // Reset to 1
                }
                if (quantityDecrease) quantityDecrease.disabled = true;
                if (quantityIncrease) quantityIncrease.disabled = true;
            } else {
                stockStatus.textContent = versaTranslate('Out of stock', 'versa');
                stockStatus.className = 'user-product-stock-status font-medium text-red-600';
                addToCartBtn.disabled = true;
                addToCartBtn.querySelector('.add-to-cart-text').textContent = versaTranslate('Out of stock', 'versa');
                addToCartBtn.className = 'user-product-add-to-cart bg-gray-400 text-white px-3 py-1.5 rounded text-xs font-medium flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed';
                
                // Disable quantity controls
                if (quantityInput) {
                    quantityInput.disabled = true;
                    quantityInput.value = 1; // Reset to 1
                }
                if (quantityDecrease) quantityDecrease.disabled = true;
                if (quantityIncrease) quantityIncrease.disabled = true;
            }
        }
        
        // Add event listeners for quantity controls
        if (quantityDecrease) {
            quantityDecrease.addEventListener('click', (e) => {
                e.stopPropagation();
                const input = e.target.closest('.user-product-reorder-section').querySelector('.user-product-reorder-quantity');
                const currentValue = parseInt(input.value) || 1;
                if (currentValue > 1) {
                    input.value = currentValue - 1;
                }
            });
        }
        
        if (quantityIncrease) {
            quantityIncrease.addEventListener('click', (e) => {
                e.stopPropagation();
                const input = e.target.closest('.user-product-reorder-section').querySelector('.user-product-reorder-quantity');
                const currentValue = parseInt(input.value) || 1;
                const maxStock = parseInt(input.getAttribute('max')) || 999;
                if (currentValue < maxStock) {
                    input.value = currentValue + 1;
                }
            });
        }
        
        // Add event listener for add to cart
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                // Update quantity attribute before add to cart
                const currentQuantity = parseInt(quantityInput.value) || 1;
                addToCartBtn.setAttribute('data-quantity', currentQuantity);
                
                // Show loading state
                const textSpan = addToCartBtn.querySelector('.add-to-cart-text');
                const originalText = textSpan.textContent;
                textSpan.textContent = versaTranslate('Adding...', 'versa');
                addToCartBtn.disabled = true;
                
                // Trigger WooCommerce add to cart via AJAX
                const ajaxData = {
                    action: 'woocommerce_add_to_cart',
                    product_id: product.id,
                    quantity: currentQuantity
                };
                
                if (product.variation_id && product.variation_id !== '0') {
                    ajaxData.variation_id = product.variation_id;
                }
                
                // Use jQuery AJAX to match theme's approach
                jQuery.post(wc_add_to_cart_params.ajax_url, ajaxData)
                    .done((response) => {
                        textSpan.textContent = versaTranslate('Added!', 'versa');
                        addToCartBtn.classList.remove('bg-versa-700', 'hover:bg-versa-800');
                        addToCartBtn.classList.add('bg-green-600');

                        if (response.fragments) {
                            jQuery.each(response.fragments, function(selector, fragment) {
                                jQuery(selector).replaceWith(fragment);
                            });
                        }

                        if (response.cart_hash) {
                            jQuery(document.body).trigger('wc_fragment_refresh');
                        }

                        setTimeout(() => {
                            textSpan.textContent = originalText;
                            addToCartBtn.disabled = false;
                            addToCartBtn.classList.remove('bg-green-600');
                            addToCartBtn.classList.add('bg-versa-700', 'hover:bg-versa-800');
                            addToCartBtn.quantity = 1;
                        }, 2000);
                    })
                    .fail(() => {
                        textSpan.textContent = versaTranslate('Error', 'versa');
                        addToCartBtn.classList.add('bg-red-600');
                        setTimeout(() => {
                            textSpan.textContent = originalText;
                            addToCartBtn.disabled = false;
                            addToCartBtn.classList.remove('bg-red-600');
                        }, 2000);
                    });
            });
        }
        
        // Set up expansion functionality
        const productSummary = clone.querySelector(".user-product-summary");
        const productExpandable = clone.querySelector(".user-product-expandable");
        
        productSummary.dataset.productIndex = productIndex;
        productExpandable.id = 'user-product-expandable-' + productIndex;
        
        // Add click handler for product expansion (but not on reorder section)
        productSummary.addEventListener('click', (e) => {
            // Don't expand if clicking on reorder section
            if (e.target.closest('.user-product-reorder-section, .user-product-link')) {
                return;
            }
            this.toggleProductExpansion(productIndex, product);
        });
        
        return clone;
    }

}

if (window.location.href.includes('/my-account/products')) {
    (function () {
        const sortEl = document.getElementById('user-products-order')
        const userProducts =  new AccountData('name', 'desc', 'user-products', 'products');

        if (sortEl) {
            sortEl.addEventListener('input', function (event) {
                const selection = this.value.split('-');
                userProducts.ordering = {order_by: selection[0], order: selection[1]}
            }, false);
        }
    })();
}

if (window.location.href.includes('/my-account/orders')) {
    (function () {
        const sortEl = document.getElementById('user-orders-order')
        const userProducts =  new AccountData('name', 'desc', 'user-orders', 'orders');

        if (sortEl) {
            sortEl.addEventListener('input', function (event) {
                const selection = this.value.split('-');
                userProducts.ordering = {order_by: selection[0], order: selection[1]}
            }, false);
        }
    })();
}